import type { Workshop } from '../lib/workshop';
import { z } from 'zod';

export type VimeoEventInfo = {
  title: string;
  description: string;
  videoId: string;
  createdAt: string;
  thumbnailUrl?: string;
  viewCount: number;
  isLive: boolean;
};

export type RetrieveVimeoEventsResponse = {
  events: VimeoEventInfo[];
};

export const createWorkshopSchema = z.object({
  title: z.string(),
  description: z.string(),
  vimeoEventId: z.string(),
  scheduledAt: z.coerce.date(),
  presenter: z.string(),
  schedulingLink: z.string().optional(),
});

export type CreateWorkshopBody = z.infer<typeof createWorkshopSchema>;

export type CreateWorkshopResponse = {
  message: string;
};

export const listWorkshopsQuerySchema = z.object({
  showCompleted: z.coerce.boolean().default(false),
});

export type ListWorkshopsQueryInput = z.input<typeof listWorkshopsQuerySchema>;
export type ListWorkshopsQuery = z.infer<typeof listWorkshopsQuerySchema>;

export type ListWorkshopsResponse = {
  workshops: Workshop[];
};

export const updateWorkshopParamsSchema = z.object({
  id: z.string(),
});

export const updateWorkshopSchema = createWorkshopSchema;

export type UpdateWorkshopParams = z.infer<typeof updateWorkshopParamsSchema>;
export type UpdateWorkshopBody = z.infer<typeof updateWorkshopSchema>;
export type UpdateWorkshopResponse = {
  message: string;
};

// Delete workshop schemas and types
export const deleteWorkshopParamsSchema = z.object({
  id: z.string(),
});

export type DeleteWorkshopParams = z.infer<typeof deleteWorkshopParamsSchema>;
export type DeleteWorkshopResponse = {
  message: string;
};

// Toggle workshop completed status schemas and types
export const toggleWorkshopCompletedParamsSchema = z.object({
  id: z.string(),
});

export type ToggleWorkshopCompletedParams = z.infer<
  typeof toggleWorkshopCompletedParamsSchema
>;
export type ToggleWorkshopCompletedResponse = {
  workshop: Workshop;
};
